import { useReduxState } from 'hooks';
import { EmptyIndicator } from 'components/common';
import { Box } from 'components/common/box';
import { ConversationAnalysisQuestionsItem } from '.';

import type { AchievementDiscussionAnalysisResult } from 'shared-types';

interface Props {
  numberOfAnswersByQuestionId: { [questionId: string]: number };
  questions: AchievementDiscussionAnalysisResult['questions'];
  sentimentAnalysisPerQuestion: AchievementDiscussionAnalysisResult['sentimentAnalysisPerQuestion'];
}

const ConversationAnalysisQuestions = ({
  numberOfAnswersByQuestionId,
  questions,
  sentimentAnalysisPerQuestion
}: Props) => {
  const { messages, theme } = useReduxState();

  const questionIds = Object.keys(questions || {});

  return (
    <Box title={messages.commonQuestions}>
      <div className="questions">
        {questionIds.length ? (
          <div className="questions">
            {questionIds.map((questionId, questionIndex) => {
              const question = questions[questionId];
              const analysis = sentimentAnalysisPerQuestion?.[questionId];

              return (
                <div className="question" key={questionId}>
                  <ConversationAnalysisQuestionsItem
                    number={questionIndex + 1}
                    numberOfAnswers={
                      numberOfAnswersByQuestionId[questionId] || 0
                    }
                    question={question}
                    analysis={analysis}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <EmptyIndicator
            icon={['far', 'comment']}
            title={messages.commonNoData}
          />
        )}

        <style jsx>{`
          .questions {
            display: flex;
            flex-direction: column;
            gap: 25px;
          }
        `}</style>
      </div>
    </Box>
  );
};

export default ConversationAnalysisQuestions;
